import { useAuth } from "@/context/Auth/AuthProvider";
import { USER_ROLES_RAW_DATA } from "@/roles/types/enums";
import { NAVIGATION_ITEMS, ROUTES } from "@/shared";
import { isItemVisible } from "@/shared/layout";

export const useHomeRoute = () => {
  const { tokenInfo, user } = useAuth();

  const canAccessDashboard = isItemVisible(
    NAVIGATION_ITEMS.Dashboard,
    user?.role !== USER_ROLES_RAW_DATA.User
  );

  const getHomeRoute = () => {
    if (!tokenInfo) {
      return ROUTES.Home;
    }

    if (canAccessDashboard) {
      return ROUTES.Dashboard;
    }

    return ROUTES.Vehicles;
  };

  const homeRoute = getHomeRoute();

  return { canAccessDashboard, homeRoute };
};
